import styled, { css } from "styled-components"
import { space } from "styled-system"
import { isIOS, isTablet } from "react-device-detect"

import Div from "../components/div/div.component"

const largeCopyStyling = css`
  ${({ theme: { typography } }) => typography.desktop.inlineCTA}
`
const smallCopyStyling = css`
  ${({ theme: { typography } }) => typography.desktop.largeInlineCTA}
`

const changeFontSize = ({ typoSize }) => {
  if (typoSize === "large") return largeCopyStyling
  else return smallCopyStyling
}

export const HeroDescriptionContainer = styled(Div)`
  ${({ theme: { typography } }) => typography.desktop.largeInlineCTA};
  ${changeFontSize}
  & p {
    padding-bottom: 15px;
    color: ${({ theme: { colors } }) => colors.darkGrey};
  }
  & a {
    color: ${({ theme: { colors } }) => colors.hyperLinkPink};
  }

  @media screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.inlineCTA};
  }
`

HeroDescriptionContainer.displayName = "HeroDescriptionContainer"

// About Description font size is 20/30 & need more paragraph margin
export const AboutDescriptionContainer = styled(HeroDescriptionContainer)`
  & p {
    margin: 1em 0;
  }
  ${({ theme: { typography } }) => typography.desktop.body};
`

const getListStyling = () => {
  if (isIOS && isTablet) {
    return css`
      padding-left: 32px !important;
    `
  } else {
    return css`
      padding-left: 24px !important;
    `
  }
}

// This is for privacy, cookie, terms page
export const TermsContentContainer = styled(Div)`
  ${space};
  & a {
    color: ${({ theme: { colors } }) => colors.hyperLinkPink};
  }
  & h1 {
    margin-bottom: 25px;
    ${({ theme: { typography } }) => typography.desktop.h1};
  }
  & h2 {
    margin-bottom: 35px;
    margin-top: 60px;
    ${({ theme: { typography } }) => typography.desktop.h2};
  }
  & h3 {
    margin-bottom: 100px;
    color: ${({ theme: { colors } }) => colors.darkGrey};
    ${({ theme: { typography } }) => typography.desktop.inlineCTA};
  }
  & p {
    margin: 1.8em 0;
    color: ${({ theme: { colors } }) => colors.darkGrey};
    ${({ theme: { typography } }) => typography.desktop.body};
  }
  ul {
    margin-bottom: ${({ letterpoint }) => (letterpoint ? "40px" : "initial")};
    ${getListStyling}/*ipad thing*/
  }
  ul:last-of-type {
    li {
      list-style-type: ${({ letterpoint }) =>
        letterpoint ? "lower-alpha" : "initial"};
      padding-left: 13px;
    }
  }
  li {
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.light};
    font-size: 20px;
    line-height: 30px;
    margin: 1em 0;
    padding-left: 8px;
  }
  li::marker {
    color: ${({ theme: { colors } }) => colors.accentBlue};
    font-size: 22px;
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  }
  @media screen and (max-width: 940px) {
    & h3 {
      margin-bottom: 60px; /*as soon as we see burger menu reduce spacing below text 'Last udpated..'*/
    }
  }
  @media screen and (max-width: 760px) {
    & h1 {
      margin-bottom: 15px;
      ${({ theme: { typography } }) => typography.mobile.h1};
    }
    & h2 {
      margin-bottom: 20px;
      ${({ theme: { typography } }) => typography.mobile.h2};
    }
    & h3 {
      ${({ theme: { typography } }) => typography.mobile.inlineCTA};
    }
    & p {
      margin: 0 0 1.8em;
      color: ${({ theme: { colors } }) => colors.darkGrey};
      ${({ theme: { typography } }) => typography.mobile.body};
      & em {
        display: block;
        margin-bottom: -31px;
      }
    }
    li {
      font-size: 18px;
      line-height: 28px;
    }
    li::marker {
      font-size: 16px;
    }
  }
`
